import {match} from 'ts-pattern';

import {isArray} from 'ramda-adjunct';

import {customerRoutes, testIds} from '@dms/routes';
import {DmsDataGrid} from '@dms/shared';

import {composePath, noop} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

const PREDEFINED_COLUMNS = ['customerId'] as const;

export function GdprConsentsOverview() {
  const actionCallback: ActionCallback<typeof PREDEFINED_COLUMNS> = ({
    actionKey,
    rowId,
    getColumnData,
  }) => {
    match(actionKey)
      .with('openOnNewTab', () => {
        const customerId =
          getColumnData('customerId')?.value ?? (isArray(rowId) ? rowId[0] : rowId);

        if (!customerId) {
          return;
        }

        const path = composePath(customerRoutes.GDPRConsents, {
          params: {id: String(customerId)},
          isSearchParamsPreserved: false,
        });
        window.open(path);
      })
      .otherwise(noop);
  };

  return (
    <DmsDataGrid
      data-testid={testIds.customer.gdprConsentsOverview('datagrid')}
      gridCode="gdpr-consent"
      actionCallback={actionCallback}
      predefinedColumns={PREDEFINED_COLUMNS}
    />
  );
}
